const GDKEY = "135f0909f54e9004aa6d522114245c0f";
const ROADKEY = '6a54e744145f10fc2fe683e3e8578931';

const jsApiList = ['onMenuShareAppMessage', 'onMenuShareTimeline', 'translateVoice', 'onMenuShareQQ', 'onMenuShareWeibo'];
// const secret='63cc4b5ae5a5d7985d4005e896f4ebaa';
// const appId='wx90436f4195735633' // 必填，公众号的唯一标识
// const timestamp=new time() // 必填，生成签名的时间戳

export default {
    GDKEY,
    ROADKEY,
    jsApiList
}


// WEBPACK FOOTER //
// ./src/config.js